/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'table': {
    width: 64,
    height: 64,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M67.04 100.41h889.919v200.232H67.039V100.411zM67.04 345.139h266.976v266.975H67.039V345.14zM67.04 656.61h266.976v266.977H67.039V656.611zM378.511 345.139h266.977v266.975H378.51V345.14zM378.511 656.61h266.977v266.977H378.51V656.611zM689.983 345.139H956.96v266.975H689.983V345.14zM689.983 656.61H956.96v266.977H689.983V656.611z"/><path pid="1" d="M67.04 100.41h889.919v200.232H67.039V100.411zM67.04 345.139h266.976v266.975H67.039V345.14zM67.04 656.61h266.976v266.977H67.039V656.611zM378.511 345.139h266.977v266.975H378.51V345.14zM378.511 656.61h266.977v266.977H378.51V656.611zM689.983 345.139H956.96v266.975H689.983V345.14zM689.983 656.61H956.96v266.977H689.983V656.611z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/table.js